import isNetworkError from 'is-network-error'
import { isHTTPError, isTimeoutError } from 'ky'
import { m } from '~/paraglide/messages'
import { dialog } from '@forest/shared/react'

/**
 * Shared mutation-failure dialog cascade: connection issues → HTTP status →
 * generic fallback. Callers handle their domain-specific errors first and
 * fall through to this for everything else.
 */
export function openMutationErrorDialog(error: unknown) {
  if (
    isTimeoutError(error) ||
    (isNetworkError as (err: unknown) => boolean)(error)
  ) {
    dialog.open({
      title: m.dialog_connection_issue_title(),
      description: m.dialog_connection_issue_description(),
      button: m.OK(),
    })
    return
  }

  if (isHTTPError(error)) {
    dialog.open({
      title: m.dialog_error_occur_title(),
      description: m.error_code_general({
        status: error.response.status,
      }),
      button: m.OK(),
    })
    return
  }

  dialog.open({
    title: m.dialog_error_occur_title(),
    description: m.dialog_error_occur_description({
      status: String(error),
    }),
    button: m.OK(),
  })
}
